import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Downshift from '@rexlabs/downshift';
import { MENU_STATES, CUSTOM_STATE_CHANGE_TYPES, DownshiftContext, useDownshiftContext } from '../../../core';
import { debounce as lodashDebounce, noop } from 'lodash';
var DownshiftProvider = DownshiftContext.Provider;
var defaultItems = [];
export function useBaseSelect(_ref) {
  var id = _ref.id,
      name = _ref.name,
      multi = _ref.multi,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 0 : _ref$debounce,
      _ref$minChars = _ref.minChars,
      minChars = _ref$minChars === void 0 ? 0 : _ref$minChars,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? defaultItems : _ref$items,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      _ref$onInputValueChan = _ref.onInputValueChange,
      onInputValueChange = _ref$onInputValueChan === void 0 ? noop : _ref$onInputValueChan,
      _ref$stateReducer = _ref.stateReducer,
      stateReducer = _ref$stateReducer === void 0 ? function (_, changes) {
    return changes;
  } : _ref$stateReducer;
  var hasFocusedOnce = React.useRef(false);

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      itemsResolver = _React$useState2[0],
      setItemsResolver = _React$useState2[1]; // NOTE: This does not affect what is currently in the text input
  // We set the initial value of inputValueCopy to an empty string
  // because generally we don't want to search with the currently
  // selected item on the initial mount so we wait until the user
  // has typed something into the input to search
  // Base Selects will also typically deal with rendering values
  // outside of the input anyway so it should always start empty


  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      inputValueCopy = _React$useState4[0],
      setInputValueCopy = _React$useState4[1];

  React.useEffect(function () {
    if (inputValueCopy.length >= minChars && hasFocusedOnce.current) {
      setItemsResolver(typeof items === 'function' ? items(inputValueCopy) : items);
    }
  }, [inputValueCopy, minChars, items]); // Memoized to ensure that the debounce function
  // created here is the same one used every time

  var debounceSetInputValueCopy = React.useMemo(function () {
    return lodashDebounce(setInputValueCopy, debounce);
  }, [debounce]); // Only use the debounce function if we need to

  var actualSetInputValueCopy = debounce === 0 ? setInputValueCopy : debounceSetInputValueCopy;
  var stateReducerOverride = React.useCallback(function (state, changes) {
    var _context;

    var newChanges = changes;

    switch (changes.type) {
      // Only remove the last selected item
      // instead of all of them
      case CUSTOM_STATE_CHANGE_TYPES.BACKSPACE_REMOVE:
        newChanges = _objectSpread(_objectSpread({}, changes), {}, {
          selectedItem: _Array$isArray(state.selectedItem) ? _sliceInstanceProperty(_context = state.selectedItem).call(_context, 0, state.selectedItem.length - 1) : changes.selectedItem
        });
        break;
    }

    return stateReducer(state, newChanges);
  }, [stateReducer]);
  var handleOnChange = React.useCallback(function (selectedItem) {
    onChange({
      persist: function persist() {
        return null;
      },
      target: {
        id: id,
        name: name,
        type: 'select',
        value: selectedItem
      }
    });
    onBlur();
  }, [id, name, onChange, onBlur]);
  var handleInputValueChange = React.useCallback(function (value, stateAndHelpers) {
    var type = stateAndHelpers.type,
        inputValue = stateAndHelpers.inputValue,
        menuState = stateAndHelpers.menuState,
        setMenuState = stateAndHelpers.setMenuState; // Only update the value of our copy when we actually type into the input

    if (type === Downshift.stateChangeTypes.changeInput) {
      actualSetInputValueCopy(inputValue);

      if (isSearchable && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) >= minChars && menuState !== MENU_STATES.LOADING) {
        setMenuState(MENU_STATES.LOADING);
      }
    }

    if (isSearchable && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < minChars) {
      setItemsResolver([]);
      setInputValueCopy(inputValue);
      setMenuState(MENU_STATES.HELPER);
    }

    onInputValueChange(value, stateAndHelpers);
  }, [actualSetInputValueCopy, isSearchable, minChars, onInputValueChange]);
  var BaseSelectCoreInner = React.useMemo(
  /* eslint-disable */
  function () {
    return function (_ref2) {
      var children = _ref2.children;
      var downshift = useDownshiftContext();
      var setMenuState = downshift.setMenuState,
          _getInputProps = downshift.getInputProps,
          _getToggleButtonProps = downshift.getToggleButtonProps;

      var createHandleOnFocus = function createHandleOnFocus(onFocus) {
        return function (event) {
          if ((!isSearchable || minChars <= 0) && !hasFocusedOnce.current) {
            var newItems = typeof items === 'function' ? items('') : items; // Imperetively set the menu state so there
            // isn't any janky transitions from the initial state

            if (_Array$isArray(newItems)) {
              if (newItems.length > 0) {
                setMenuState(MENU_STATES.HAS_ITEMS);
              } else {
                setMenuState(MENU_STATES.NO_RESULTS_FOUND);
              }
            } else {
              setMenuState(MENU_STATES.LOADING);
            }

            setItemsResolver(newItems);
          }

          hasFocusedOnce.current = true;
          onFocus(event);
        };
      };

      var customDownshift = _objectSpread(_objectSpread({}, downshift), {}, {
        multi: multi,
        minChars: minChars,
        getInputProps: function getInputProps() {
          var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var _ref3$onFocus = _ref3.onFocus,
              onFocus = _ref3$onFocus === void 0 ? noop : _ref3$onFocus,
              inputProps = _objectWithoutProperties(_ref3, ["onFocus"]);

          return _getInputProps(_objectSpread(_objectSpread({}, inputProps), {}, {
            onFocus: createHandleOnFocus(onFocus)
          }));
        },
        getToggleButtonProps: function getToggleButtonProps() {
          var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var _ref4$onFocus = _ref4.onFocus,
              onFocus = _ref4$onFocus === void 0 ? noop : _ref4$onFocus,
              toggleButtonProps = _objectWithoutProperties(_ref4, ["onFocus"]);

          return _getToggleButtonProps(_objectSpread(_objectSpread({}, toggleButtonProps), {}, {
            onFocus: createHandleOnFocus(onFocus)
          }));
        }
      });

      return /*#__PURE__*/React.createElement(DownshiftProvider, {
        value: customDownshift
      }, children);
    };
  },
  /* eslint-enable */
  [isSearchable, items, minChars, multi]);
  return {
    stateReducer: stateReducerOverride,
    itemsResolver: itemsResolver,
    handleOnChange: handleOnChange,
    handleInputValueChange: handleInputValueChange,
    BaseSelectCoreInner: BaseSelectCoreInner
  };
}